import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PremiumRotatingSection = () => {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);
  const textRefs = useRef([]);

  const statistics = [
    { label: "33+ GODINA ISKUSTVA", bg: "#F3F4F6" },
    { label: "5000+ ZADOVOLJNIH KLIJENATA", bg: "#F3F4F6" },
    { label: "100+ STRUČNJAKA U TIMU", bg: "#F3F4F6" }
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: `+=${statistics.length * 150}%`, // Malo duži skrol za bolji osećaj
          pin: true,
          scrub: 1, // Veći scrub za "glatkiji" osećaj (inerciju)
        }
      });

      // Postavljanje početnih stanja
      textRefs.current.forEach((el, i) => {
        const words = el.querySelectorAll('.word');
        if (i !== 0) {
          gsap.set(words, { rotateX: -90, opacity: 0, y: 40 });
        }
      });

      statistics.forEach((stat, i) => {
        // Promena boje pozadine celog sekcije
        tl.to(sectionRef.current, {
          backgroundColor: stat.bg,
          duration: 1,
          ease: "power1.inOut"
        }, i);

        if (i < statistics.length - 1) {
          const currentWords = textRefs.current[i].querySelectorAll('.word');
          const nextWords = textRefs.current[i + 1].querySelectorAll('.word');

          // Animacija izlaska trenutnih reči (jedna po jedna)
          tl.to(currentWords, {
            rotateX: 90,
            opacity: 0,
            y: -40,
            stagger: 0.05, // Ključ za "skup" izgled
            duration: 0.8,
            ease: "power2.inOut"
          }, i + 0.5);

          // Animacija ulaska sledećih reči
          tl.to(nextWords, {
            rotateX: 0,
            opacity: 1,
            y: 0,
            stagger: 0.05,
            duration: 0.8,
            ease: "power2.inOut"
          }, i + 0.6); // Kreće delić sekunde nakon početka izlaska
        }
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section 
      ref={sectionRef} 
      className="h-screen w-full flex items-center justify-center overflow-hidden transition-colors duration-700 relative"
      style={{ contain: 'paint' }}
    >
      {/* 1. GRAINY TEXTURE OVERLAY */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] z-50"
           style={{ backgroundImage: `url('https://grainy-gradients.vercel.app/noise.svg')` }}></div>

      <div 
        className="relative w-full max-w-6xl px-10 flex items-center justify-center"
        style={{ perspective: "1500px" }}
      >
        {statistics.map((stat, i) => (
          <h2
            key={i}
            ref={(el) => (textRefs.current[i] = el)}
            className="absolute text-center text-5xl md:text-8xl lg:text-[110px] font-bold tracking-tighter text-neutral-900 leading-[0.9] uppercase flex flex-wrap justify-center gap-x-4"
            style={{ backfaceVisibility: "hidden" }}
          >
            {stat.label.split(' ').map((word, idx) => (
              <span key={idx} className="word inline-block origin-bottom">
                {word}
              </span>
            ))}
          </h2>
        ))}
      </div>

      {/* 2. PROGRESS LINE (DISKRETNA LINIJA SA STRANE) */}
      <div className="absolute right-12 h-32 w-[1px] bg-black/10 flex flex-col justify-start">
          <div className="w-full bg-black/40 h-full origin-top scale-y-0 scroll-progress-bar"></div>
      </div>
    </section>
  );
};

export default PremiumRotatingSection;